import { defineComponent, h } from 'vue';
import { QBtn, QDialog } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';
import ControlPicker from './controlPicker.jsx';
import ControlGroupDocumentPreview from './ControlGroupDocumentPreview.jsx';
import { ensureModelObjectId } from '../ControlDesigner/controlDesignerSelectionSync.js';

export default defineComponent({
    name: 'stack-vertical-content-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        QBtn,
        QDialog,
        ControlPicker,
        ControlGroupDocumentPreview
    },
    data: function () {
        return {
            controlgroup_list: [],
        }
    },
    computed: {
        direction() {
            if (this.controlData.Direction)
                return this.controlData.Direction;
            return 'Normal';
        },
        stackClasses() {
            let classes = [];
            if (this.isVertical) {
                if (this.controlData.HorizontalAlignChildren) {
                    switch (this.controlData.HorizontalAlignChildren.toLowerCase()) {
                        case 'middle': {
                            classes.push('items-center');
                            break;
                        }
                        case 'right': {
                            classes.push('items-end');
                            break;
                        }
                        default:
                            classes.push('items-start');
                            break;
                    }
                }
                else {
                    classes.push('items-start');
                }

                if (this.controlData.VerticalAlignChildren) {
                    switch (this.controlData.VerticalAlignChildren.toLowerCase()) {
                        case 'center': {
                            classes.push('justify-center');
                            break;
                        }
                        case 'bottom': {
                            classes.push('justify-end');
                            break;
                        }
                        case 'spacearound': {
                            classes.push('justify-around');
                            break;
                        }
                        case 'spacebetween': {
                            classes.push('justify-between');
                            break;
                        }
                        case 'spaceevenly': {
                            classes.push('justify-evenly');
                            break;
                        }
                        default:
                            classes.push('justify-start');
                            break;
                    }
                }
                else {
                    classes.push('justify-start');
                }
            }
            else {
                if (this.controlData.VerticalAlignChildren) {
                    switch (this.controlData.VerticalAlignChildren.toLowerCase()) {
                        case 'center': {
                            classes.push('items-center');
                            break;
                        }
                        case 'bottom': {
                            classes.push('items-end');
                            break;
                        }
                        default:
                            classes.push('items-start');
                            break;
                    }
                }
                else {
                    classes.push('items-start');
                }

                if (this.controlData.HorizontalAlignChildren) {
                    switch (this.controlData.HorizontalAlignChildren.toLowerCase()) {
                        case 'middle': {
                            classes.push('justify-center');
                            break;
                        }
                        case 'right': {
                            classes.push('justify-end');
                            break;
                        }
                        case 'spacearound': {
                            classes.push('justify-around');
                            break;
                        }
                        case 'spacebetween': {
                            classes.push('justify-between');
                            break;
                        }
                        case 'spaceevenly': {
                            classes.push('justify-evenly');
                            break;
                        }
                        default:
                            classes.push('justify-start');
                            break;
                    }
                }
                else {
                    classes.push('justify-start');
                }
            }

            return classes
        },
        isVertical() {
            const t = (this.type || '').toLowerCase();
            return t.includes('vertical') || t === 'controlcontainer' || t === 'tab';
        },
        isHorizontal() {
            const t = (this.type || '').toLowerCase();
            return t.includes('horizontal') || t === 'headerbar';
        },
        isRecursive() {
            return this.controlData?.Name?.includes("Recursive") || false;
        },
        bodyScrollOverflowStyle() {
            if (!this.isHorizontal)
                return { overflow: 'auto' };
            if (this.parentType === 'ContentDef')
                return { overflow: 'hidden' };
            return { overflowX: 'auto', overflowY: 'hidden' };
        },
    },
    watch: {
        'controlData.ControlGroupName'(newValue, oldValue) {
            if (newValue)
                this.listModuleGroupNameControls();
            else
                this.controlgroup_list = [];
        }
    },
    mounted() {
        if (this.controlData.ControlGroupName)
            this.listModuleGroupNameControls();
    },
    methods: {
        generateItems(h, controlData, items, model, index, parentType) {
            let tempItems = []
            for (let i = 0; i < controlData.Controls.length; i++) {
                const c = controlData.Controls[i];
                if (!(typeof c === 'object'))
                    continue;

                let DynamicControl = utils.getDesignerComponent(c, null);

                if (!c.$objectId) ensureModelObjectId(c);

                let id = `${this.master_key}_${c.$objectId}`;
                if (index) id = `${index}_${id}`;

                tempItems.push(
                    <DynamicControl
                        key={id}
                        type={c.ControlType}
                        name={c.ControlData ? c.ControlData.Name : ''}
                        root={this.root}
                        designmodel={c}
                        parentType={parentType}
                        controlData={c.ControlData}
                        controlURL={c.ControlURL}
                        sourceData={model}
                        sourceIndex={i}>
                    </DynamicControl>
                );
            }
            if (this.direction === 'Reversed')
                tempItems.reverse();
            items.push(...tempItems);
        },
        getHeader(h, controlData) {
            if (controlData.HeaderControls && controlData.HeaderControls.length > 0) {
                const header = [];

                for (let i = 0; i < controlData.HeaderControls.length; i++) {
                    const c = controlData.HeaderControls[i];
                    let dynamicControl = utils.getDynamicComponent(h, c, null, true) || '';

                    dynamicControl += '-dsgn';

                    let DynamicControl = utils.dynamicComponents[dynamicControl];
                    if (!DynamicControl)
                        DynamicControl = utils.dynamicComponents['default-unknown-dsgn'];

                    if (!c.$objectId) ensureModelObjectId(c);

                    let id = `${this.master_key}_${c.$objectId}_${i}`;

                    header.push(
                        <DynamicControl
                            onFinishedRender={() => this.finishRenderHandler()}
                            type={c.ControlType}
                            key={id}
                            name={c.ControlData ? (c.ControlData.Name || 'unnamed') : 'unnamed'}
                            root={this.root}
                            designmodel={c}
                            parentType="HorizontalStack"
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}>
                        </DynamicControl>
                    );
                }
                return header;
            }
            return null;
        },
        generateItemsFromModel(h, items, controlData, items_id, parentType) {
            if (controlData.Controls)
                this.generateItems(h, controlData, items, null, items_id, parentType);
        },

        async listModuleGroupNameControls() {
            this.controlgroup_list = await utils.api.get(`Apps/Modules/ListModuleGroupNameControls?GroupName=${this.controlData.ControlGroupName}`);
        },
    },
    props: {
        type: null,
        parentType: null,
        asbase: false,
    },
    render() {
        let items = [];
        let items_id = '_0';

        let controlData = this.controlData;

        let header = this.getHeader(h, controlData);
        let headerContent = null;
        if (this.selected$ || header) {
            if (this.selected$) {
                if (!header) header = [];
                header.push(
                    utils.tt('Add control to header',
                        <QBtn size="sm" flat icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 992 }} onClick={(e) => this.addControl(e, 'header')} />)
                );
            }
            if (header)
                headerContent =
                    <div style={{ display: "flex", flexDirection: "row", flexGrow: "0", flexShrink: "0", padding: "2px", paddingLeft: "8px", alignItems: 'center' }}>
                        {header}
                    </div>;
        }

        this.generateItemsFromModel(h, items, controlData, items_id, this.type);

        if (this.selected$)
            items.push(
                utils.tt('Add control to body',
                    <QBtn size="sm" flat icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 992 }} onClick={(e) => this.addControl(e, 'body')} />)
            );

        if (this.controlgroup_list.length) {
            this.controlgroup_list.forEach(c => items.push(
                <ControlGroupDocumentPreview
                    key={`${c.ModuleName}_${c.DocumentName}`}
                    documentName={c.DocumentName}
                    moduleName={c.ModuleName}
                    root={this.root}
                    parentNode={this}
                    showOpen={this.selected$}
                />
            ));
        }

        const style = {
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            ...utils.getStyleHints(controlData.StyleHints),
            minWidth: "15px",
            flexGrow: "1",
            flexShrink: "1"
        };

            //...utils.getSize(controlData.SizeOptions, this.parentType, this.$parent),

        const bodyStyle = {
            ...this.bodyScrollOverflowStyle,
            display: "flex",
            flexDirection: this.isVertical ? "column" : 'row',
            flexGrow: 1,
            //gap: this.padding ? this.padding + 'px' : ''
        };

        return (
            <div
                class={{ 'c-StackContent-Dsgn': true, [`c-name-${this.name || 'unnamed'}`]: true, 'designer-container': true, selected: this.selected$ }}
                style={style}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected-clickthrough': this.selected$ }}></div>

                {headerContent}
                <div style={bodyStyle} class={this.stackClasses}>
                    {!this.isRecursive 
                        ? items
                        : 'Recursive structure detected. If you did not expect a recursive structure, please remove "Recursive" from the name of your vertical layout'
                    }
                 </div>

                {this.generatePicker(h)}
            </div>
        );
    }
});